<template>
  <div class="footer-bottom text-bg-primary p-4 text-center">
    <p>{{ $t("prices_include_vat") }}
    <br>{{ $t("terms_and_conditions") }} - {{ $t("footer_privacy") }} - {{ $t("footer_cookies") }}
    <br>{{ $t("footer_copyright") }} {{ new Date().getFullYear() }}</p>
  </div>
</template>

<script>
import getImageUrl from "@/base/helpers/getImageUrl";

export default {
  methods: {
    imgUrl(filename) {
      return getImageUrl(filename);
    },
  },
  computed: {},
};
</script>

<style></style>
